import React from 'react';
import { withRouter } from 'react-router-dom';
import ParcelDeleteModal from './parcel_delete_modal';
import { Button } from '@progress/kendo-react-buttons'
import queryString from 'query-string'
import Lang from '../../lang'
import services from '../../services';

const EstadoJSON = {
    "10" : "Inicial",
    "11" : "Gravado",
    "12" : "Alterado",
    "13" : "Validado",
    "14" : "Processado",
}

const ProcessarDisable = {
    "11" : "Gravado",
    "12" : "Alterado",
    "14" : "Processado",
}

const GravarDisable = {
    
}

const ValidarDisable = {
    "10" : "Inicial"
}

const FinalizarDisable = {
    "10" : "Inicial",
    "11" : "Gravado",
    "12" : "Alterado",
    "14" : "Processado",
}

class BoletimFormNavbar extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            deletePopUp : "",
            pdfURL:null,
            finalizarModal: ''
        }
    }

    handleFinlaizar = (e) => {
        let finalizarModal = ''
        finalizarModal = (
            <div class="modal-content" >
                <div class="modal-header popheader">
                    <span className="k-icon k-i-warning mt-1 mr-2"></span>
                    <h5 class="modal-title mr-auto" id="ModalLabel">Ao finalizar o boletim, este será enviado para a fase seguinte do processo (enquadramento legal), deixando de estar disponível para edição.</h5>
                </div>
                <div class="modal-footer popfooter">
                    <Button type="button" name="no" class="k-primary btn-ivdp-secondary" data-dismiss="modal">Não</Button>
                    <Button type="button" name="yes" class="k-button k-primary btn-ivdp-primary" data-dismiss="modal" onClick={() => this.props.handleSubmit(e, 'finalizar')}>sim</Button>
                </div>
            </div>
        )
        this.setState({
            finalizarModal
        })
    }

    goBack = () => {
        // console.log("Hiii",this.props)
        let topBarMenu = this.props.topBarMenu || {}
        if(this.props.to === '/rotulos'){
            let paramoption = {}
            if(this.props.parsed.evaluator == 1){
                paramoption = {
                    name: '1ª avaliação',
                    url: 'rotulos',
                    tableName: "RotulosOneAvalicao"
                }
            }else if(this.props.parsed.evaluator == 2){
                paramoption = {
                    name: '2ª avaliação',
                    url: 'rotulos',
                    tableName: "RotulosTwoAvalicao"
                }
            }else {
                paramoption = {
                    name: 'Pendentes',
                    url: 'rotulos',
                    tableName: "RotulosPendentes"
                }
            }
            this.props.history.push({
                pathname : "/rotulos",
                state: {paramoption, topBarMenu}
            })
        }else{
            this.props.history.push({
                pathname : this.props.to,
                state : {topBarMenu : topBarMenu}
            })
        }
    }

    render(){
        let query = queryString.parse(window.location.search)
        let id = ''
        if(query.id){
            id = query.id
        }
        return(
            <div>
            <nav className="navbar navbar-expand-md nav-bar-2 navbar-dark justify-content-end navbar-fixed-top">
                <div className="container-fluid">
                    {
                        !this.props.noCancelarEVoltarBtn ?
                        <span className="navbar-brand desktop-view min-w-300 cursor-pointer" onClick={this.goBack}>
                            <span className="k-icon k-i-arrow-left"></span>  Cancelar e voltar
                        </span>
                        :
                        <span className="navbar-brand desktop-view min-w-300 cursor-pointer">
                            <span></span>
                        </span>
                    }
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    
                    {
                        <div className="font-23 top-head">
                            <span className={`sivdp-icon sivdp-${this.props.type} mr-3 text-grey`}></span>
                            {Lang.langCheck.langRequest(this.props.headName)}
                        </div> 
                     
                    }
                    {
                        <div className="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                            <div>
                                <span><strong>Estado Boletim : </strong> 
                                    {
                                        EstadoJSON[this.props.estado]
                                    }
                                </span>
                                <div style={{marginTop:"5px"}} className="d-flex justify-content-between">
                                    <Button disabled={ValidarDisable[this.props.estado] ? true : false} onClick={(e)=>this.props.handleSubmit(e,'validar')}  primary={true} className="btn-ivdp-primary btn-sm ml-2">Validar</Button>
                                    
                                    <Button disabled={GravarDisable[this.props.estado] ? true : false} onClick={(e)=>this.props.handleSubmit(e,'gravar')} primary={true} className="btn-ivdp-primary btn-sm mr-4">Gravar</Button>
                                </div>
                                
                                <div className="d-flex flex-column" style={{marginTop:"10px"}}>
                                    <Button disabled={FinalizarDisable[this.props.estado] ? true : false} onClick={(e)=>this.handleFinlaizar(e)} primary={true} className="btn-ivdp-primary mr-2 btn-sm" data-target="#finalizar-popup" data-toggle="modal">Finalizar Boletim</Button>
                                    
                                    <Button disabled={!ProcessarDisable[this.props.estado] ? true : false} onClick={(e)=>this.props.handleSubmit(e,'processar')} primary={true} className="btn-ivdp-primary ml-0 mr-2 mt-2 btn-sm">Processar para Parcela</Button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                
            </nav>
            {
                <div className="modal" id="finalizar-popup">
                    <div className="modal-dialog modal-lg">
                        {this.state.finalizarModal}
                    </div>
                </div>
            }
            
            </div>
            
        )
    }
}

export default withRouter(BoletimFormNavbar);